import { toast } from 'react-hot-toast';
import axios from 'axios';

export default async function downloadAnalysis(
  testId,
  packId,
  userId,
  userToken,
  setDownloadAnalysisDisable = () => {},
) {
  try {
    setDownloadAnalysisDisable(true);
    const response = await axios.post('https://z2ehidvf09.execute-api.ap-south-1.amazonaws.com/quizrr-puppeteer', {
      userId: userId,
      testId: testId,
      packId: packId,
      token: userToken,
      isTestAnalysis: true,
    });

    const data = response?.data;

    if (data?.url) {
      window.open(data.url, '_blank')?.focus();
      setDownloadAnalysisDisable(false);
    } else if (data?.message === 'ok') {
      toast.success(
        <div className="flex flex-col items-start">
          <p>Analysis PDF generation started.</p>
          <p>You will receive it on your email when ready.</p>
        </div>,
        {
          position: 'top-center',
          duration: 1800,
        },
      );
    }
  } catch (error) {
    // You can optionally show a toast for error
    toast.error('Something went wrong while generating the PDF.', {
      position: 'top-center',
      duration: 1000,
    });
  }
}
